import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from '../data.service';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-form-solicitudes',
  templateUrl: './form-solicitudes.component.html',
  styleUrls: ['./form-solicitudes.component.css']
})
export class FormSolicitudesComponent implements OnChanges {
  @Input() filtrosExternos: { campo: string, valor: any }[] = [];
  
  registros;
  registrosOriginales: any[] = []; // copia para filtrar localmente
  columnas;
  hayRegistros: boolean = true;
  editarRegistro: boolean = false;
  idRegistro: string;
  idFormulario: string;
  Registro: any;
  crearRegistro: boolean = false;
  pagina: number = 1;
  tampag: number = 1000000; // Carga masiva para paginación local en p-table
  total;
  totalPaginas;
  saltar=0;


  opciones = [];
  columnasSeleccionadas = [];
  PermisoEliminar: boolean = false;
  PermisoVer: boolean = false;
  PermisoEditar: boolean = false;
  PermisoCrear: boolean = false;
  token: any;
  permisoEncuesta: any;
  ordencampos: string[] = [];
  private ultimaPromocionConsultada: any = undefined;
  
  // Getter público para acceder desde el HTML
  get promocionActual(): any {
    return this.ultimaPromocionConsultada;
  }

  private toNumberIfPossible(valor: any) {
    const num = Number(valor);
    return isNaN(num) ? valor : num;
  }

  constructor(public data: DataService, private route: ActivatedRoute, private router: Router, private messageService: MessageService) {
    this.ObtenerRegistros();
    this.ObtenerCampos();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Aplica filtros si cambian
    if (changes['filtrosExternos']) {
      console.log('Filtros externos cambiaron:', changes['filtrosExternos'].currentValue);
      // Si cambian los filtros externos, recargamos desde la API
      this.ObtenerRegistros();
    }
  }

  /* 
   * Método retirado o simplificado ya que ahora se filtra en backend.
   * Se mantiene por si se quisiera filtrar en memoria datos ya cargados,
   * pero la instrucción es usar la API.
   */
  aplicarFiltrosExternos() {
    // Ya no filtra localmente 'registrosOriginales',
    // ahora el filtrado es server-side en ObtenerRegistros.
  }

  private establecerPermisos() {
    const token = sessionStorage.getItem('token');
    if (token) {
        const decodedToken: any = jwtDecode(token);
        this.token=JSON.stringify(decodedToken);
        //this.permisoEncuesta = decodedToken.Permisos.find((permiso: any) => permiso.IdEncuesta == this.idEncuesta);
        // Si no hay idEncuesta, asumimos permisos básicos o buscamos genéricos si aplica
        // Para Solicitudes, los permisos podrían venir dados por el rol general
        this.permisoEncuesta = null; 
        var esadmin=decodedToken.Rol=="admin";

        if (this.permisoEncuesta) {
            this.PermisoEliminar = this.permisoEncuesta?.Eliminar || false;
            this.PermisoVer = this.permisoEncuesta?.Ver || false;
            this.PermisoEditar = this.permisoEncuesta?.Editar || false;
            this.PermisoCrear = this.permisoEncuesta?.Crear || false;
        }

        if (esadmin)
        {
          this.PermisoEliminar = true;
          this.PermisoVer = true;
          this.PermisoEditar = true;
          this.PermisoCrear = true;
        }
    }
  }

  filtrar()
  {

    this.ObtenerRegistros();
  }

  eliminarRegistro(IdRegistro){
    console.log('eliminar registro');
    console.log(IdRegistro);
    //confirmar eliminación
    if (!confirm('¿Está seguro de que desea eliminar este registro?')) {
      return;
    }
    this.data.EliminarRegistro(IdRegistro).subscribe(
      {
        next: (x) => {      
          console.log('Registro eliminado');
          this.ObtenerRegistros();
        },
        error: (error) => {
          console.error('Error al eliminar registro:', error);
        }
      }
    );
  }

  extraerColumnas(datos, { ordenar = false } = {}) {
    if (!Array.isArray(datos) || datos.length === 0) return [];
  
    const set = new Set();
  
    for (const fila of datos) {
      if (fila && typeof fila === "object") {
        Object.keys(fila).forEach(k => set.add(k));
      }
    }
  
    const columnas = [...set];
    return ordenar ? columnas.sort() : columnas;
  }

  ObtenerRegistros() 
  {
    console.log('ObtenerSolicitudes llamado (endpoint Portal_ObtenerSolicitudes_promociones.js). Filtros:', this.filtrosExternos);
    

    const promocion =
      this.filtrosExternos?.find(f => f.campo === 'promocion')?.valor ??
      this.route.snapshot.queryParamMap.get('promocion');

    if (promocion === this.ultimaPromocionConsultada) {
      return; // evita llamadas repetitivas con la misma promoción
    }
    this.ultimaPromocionConsultada = promocion;

    this.data.ObtenerSolicitudesPromociones(
      promocion,
      this.pagina,
      this.tampag,
      this.saltar
    ).subscribe(
      {
        next: (x) => {      
          this.registros = x.registros ?? x.solicitudes ?? x.data ?? [];
          // columnas desde respuesta; si no, derivar de registros; si siguen vacías, usar ordencampos
          // Usar siempre las columnas derivadas de los campos (ordencampos)
          const derivadas = Array.from(new Set(this.ordencampos));
          this.columnas = derivadas.length > 0 ? derivadas : this.extraerColumnas(this.registros);

          const nuevoArrayColumnas: string[] = [];
          const setColumnas = new Set<string>();
          this.ordencampos.forEach(campo => {
            if (this.columnas.includes(campo) && !setColumnas.has(campo)) {
              setColumnas.add(campo);
              nuevoArrayColumnas.push(campo);
            }
          });
          if (nuevoArrayColumnas.length > 0) {
            this.columnas = nuevoArrayColumnas;
          }
          console.log("================COLUMNAS (Solicitudes)================");
          console.log(this.columnas);

          this.total = x.total ?? this.registros.length;
          this.totalPaginas = Math.ceil(this.total / this.tampag);
          console.log("================SOLICITUDES RECIBIDAS================");
          console.log(x);
          
          let registrosProcesados = this.convertirArraysEnCadenas(this.registros);
          registrosProcesados = registrosProcesados.map(obj => this.aplanarObjeto(obj));

          this.registrosOriginales = registrosProcesados;
          this.registros = registrosProcesados;
          
          console.log("================SOLICITUDES APLANADAS================");
          console.log(this.registros);

          this.columnas = this.columnas.filter(campo => campo !== "_id");
          
          this.hayRegistros = this.registros.length > 0;
         
        },
        error: (error) => {
          if (error.status === 404) {
            console.log('No hay solicitudes');
            this.hayRegistros = false;
          } else {
            console.error('Error al listar solicitudes:', error);
          }
        }
      }
    );
  }

  ObtenerCampos(){
    // reinicia arrays para evitar duplicados entre cambios de encuesta
    this.ordencampos = [];
    this.opciones = [];

    const camposVistos = new Set<string>();
    const opcionesMap = new Map<string, {label: string; value: string}>();

    // Usar promoción para consultar campos específicos
    const filtroPromo = this.filtrosExternos?.find(f => f.campo === 'promocion')?.valor;
    const queryPromo = this.route.snapshot.queryParamMap.get('promocion');
    const promocion = filtroPromo ?? queryPromo;

    if (!promocion) {
      this.opciones = [];
      return;
    }

    const promocionNum = this.toNumberIfPossible(promocion);

    this.data.ObtenerCamposXPromocion(promocionNum).subscribe(
      {
        next: (x) => {      
          console.log('CamposXPromocion respuesta =>', x);
          var registros = x.registros || [];
          //recorrer registros para obtener los campos
          registros.forEach(element => {
            // Tomar siempre elementName como nombre de campo
            let nombrecampo = element.elementName;
            if (!nombrecampo) return;
            if (nombrecampo.startsWith("$$")) {
              nombrecampo = nombrecampo.slice(2);
            }

            const claveLower = nombrecampo.toLowerCase();
            if (camposVistos.has(claveLower)) {
              return;
            }
            camposVistos.add(claveLower);

            const registro = { label: nombrecampo, value: nombrecampo };
            this.ordencampos.push(nombrecampo);
            opcionesMap.set(claveLower, registro);
          });

          // asigna opciones únicas
          this.opciones = Array.from(opcionesMap.values());

          // Forzar columnas visibles desde ordencampos
          this.columnas = [...this.ordencampos];
          if (!this.columnas.length) {
            // fallback: derivar de registros si no vino ordencampos
            this.columnas = this.extraerColumnas(registros);
          }
          this.columnasSeleccionadas = [...this.columnas];

          // limpia columnasSeleccionadas de valores que ya no existan
          if (Array.isArray(this.columnasSeleccionadas)) {
            const permitidas = new Set(this.opciones.map(o => o.value));
            this.columnasSeleccionadas = this.columnasSeleccionadas.filter(c => permitidas.has(c));
          }
         
        },
        error: (error) => {
          // Si error es 404, no hay registros 
          if (error.status === 404) {
            console.log('No hay registros de campos para la promoción');
            this.hayRegistros = false;
          } else {
            console.error('Error al listar campos por promoción:', error);
          }
        }
      }
    );
  }

  cambiarPagina(event){
    console.log('==============nueva pagina==============');
    console.log(event.page);
    console.log(event);

    this.pagina=event.page;
    this.saltar=event.first;

    this.tampag=event.rows;

    this.ObtenerRegistros();
  }

  navigateToEditarRegistro(id: string) {
    console.log('Navegando a edición de registro:', id);
    this.editarRegistro = true;
    this.idRegistro = id;
    this.Registro = this.registros.find(x => x._id === id);
    console.log('Registro seleccionado:');
    console.log(this.Registro);
  }

  navigateToRegistro(idRegistro: string) {
    
    this.idRegistro = idRegistro;
    this.editarRegistro = true;

  }

  navigateToProgramas(patCodigo: string) {
    // Forzar navegación completa (como escribir en la barra) para recargar todo
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/pppfa'], { 
        queryParams: { 
          tab: 'Programas', 
          patrocinador: patCodigo 
        } 
      })
    );
    window.location.href = url;
  }

  navigateToPromociones(patCodigo: string, progCodigo: string) {
    // Forzar navegación completa (como escribir en la barra) para recargar todo
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/pppfa'], { 
        queryParams: { 
          tab: 'Promociones', 
          patrocinador: patCodigo,
          programa: progCodigo
        } 
      })
    );
    window.location.href = url;
  }

  navigateToFormularioPromocion(promCodigo: string, progCodigo?: string, patCodigo?: string) {
    // Forzar navegación completa a la pestaña Formularios con la promoción indicada
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/pppfa'], { 
        queryParams: { 
          tab: 'Formularios', 
          promocion: promCodigo,
          programa: progCodigo,
          patrocinador: patCodigo
        } 
      })
    );
    window.location.href = url;
  }

  onRegistroGuardado() {
    this.editarRegistro = false; // Oculta el componente de edición
    this.crearRegistro=false;
    this.idRegistro = null;
    this.ObtenerRegistros();
    this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente'});
  }

  onCreacionFinalizada() {
    this.crearRegistro = false; // Oculta el componente de creación
    this.ObtenerRegistros();
  }

  onCrearRegistro() {
    this.crearRegistro = true;
  }

  onCancelarEdicion() {
    this.editarRegistro = false;
    this.crearRegistro = false;
  }

 convertirArraysEnCadenas(arr: any[]): any[] {
  if (!Array.isArray(arr)) {
    console.error("convertirArraysEnCadenas: el valor recibido no es un array", arr);
    return [];
  }

  return arr.map(obj => {
    const nuevo = { ...obj };

    for (const clave in nuevo) {
      if (!nuevo.hasOwnProperty(clave)) continue;

      const valor = nuevo[clave];

      // ✅ 1. Convertir arrays simples a cadena
      if (Array.isArray(valor) && valor.every(item => typeof item === 'string' || typeof item === 'number')) {
        nuevo[clave] = valor.join(', ');
        continue;
      }

      // ✅ 2. Formateo de fechas: solo si el campo parece fecha (nombre) y es Date o ISO claro
      const esNombreFecha = clave.toLowerCase().includes('fecha') || clave.toLowerCase().includes('date');
      const esDateObject = Object.prototype.toString.call(valor) === '[object Date]';
      const esIsoFecha = typeof valor === 'string' && /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(valor);

      if (esNombreFecha && valor && (esDateObject || esIsoFecha)) {
        const fecha = new Date(valor);
        if (!isNaN(fecha.getTime())) {
          const yyyy = fecha.getFullYear();
          const mm = String(fecha.getMonth() + 1).padStart(2, '0');
          const dd = String(fecha.getDate()).padStart(2, '0');
          nuevo[clave] = `${yyyy}-${mm}-${dd}`;
        }
      }

    }

    return nuevo;
  });
}



    aplanarObjeto(obj, prefijo = '', resultado = {}) {
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const valor = obj[key];
    const claveCompuesta = prefijo ? `${prefijo}.${key}` : key;

    if (valor !== null && typeof valor === 'object' && !Array.isArray(valor)) {
      // Recursivamente aplana objetos internos
      this.aplanarObjeto(valor, claveCompuesta, resultado);
    } else {
      resultado[claveCompuesta] = valor;
    }
  }
  return resultado;
  }



  async descargarExcel() {
//   try {
//     // Obtener todos los registros
//     var todosLosRegistros = await this.data.ObtenerRegistros(this.idEncuesta, this.columnasSeleccionadas, 1, 100000, 0).toPromise();

//     // Procesar los registros
//     todosLosRegistros.registros = this.convertirArraysEnCadenas(todosLosRegistros.registros);
//     todosLosRegistros.registros = todosLosRegistros.registros.map(obj => this.aplanarObjeto(obj));

//     // 🟡 Ordenar cada registro según this.columnas
//     const registrosOrdenados = todosLosRegistros.registros.map(reg => {
//       const nuevoRegistro = {};
//       this.columnas.forEach(col => {
//         nuevoRegistro[col] = reg[col] !== undefined ? reg[col] : '';
//       });
//       return nuevoRegistro;
//     });

//     // Crear hoja y archivo
//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(registrosOrdenados);
//     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//     XLSX.writeFile(workbook, 'resultados.xlsx');
//   } catch (error) {
//     console.error('Error al descargar todos los registros:', error);
//   }

console.log('Descargar Excel - función no implementada completamente.');
}

}